import { render, staticRenderFns } from "./Owner.vue?vue&type=template&id=1a5dfb40&"
import script from "./Owner.vue?vue&type=script&lang=ts&"
export * from "./Owner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports